export default function arrayEach(array, iterator) {
  for (var i = 0, len = array.length; i < len; ++i) {
    iterator(array[i], i);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/arrayEach.js
// module id = 847
// module chunks = 0